export default __webpack_public_path__ + "static/media/Branding.acb599bb.svg";